import { FormControl } from '@angular/forms';
import * as validator from 'validator';

export class CfeValidators {
	static countryRegistrationEndDates: Map<string, Date> = new Map<string, Date>();

	/**
	 * Checks inputs for valid mail format
	 */
	static email(control: FormControl): { [key: string]: any } {
		if (!control.value || control.value === '' || validator.isEmail(control.value)) {
			return null;
		} else {
			return { invalidEmail: true };
		}
	}

	/**
	 * Check input for a valid url
	 */
	static url(control: FormControl): { [key: string]: any } {
		if (!control.value || control.value === '' || validator.isURL(control.value)) {
			return null;
		} else {
			return { invalidUrl: true };
		}
	}

	/**
	 * Checks inputs for valid float values
	 */
	static float(control: FormControl): { [key: string]: any } {
		if (!control.value || control.value === '' || validator.isFloat(control.value)) {
			return null;
		} else {
			return { invalidFloat: true };
		}
	}

	/**
	 * Checks inputs for valid positive float values
	 */
	static positiveFloat(control: FormControl): { [key: string]: any } {
		if (!this.float(control) && control.value > 0) {
			return null;
		} else {
			return { invalidPositiveFloat: true };
		}
	}

	/**
	 * Checks inputs for valid integer values
	 */
	static integer(control: FormControl): { [key: string]: any } {
		if (!control.value || control.value === '' || validator.isInt(control.value)) {
			return null;
		} else {
			return { invalidInteger: true };
		}
	}

	/**
	 * Checks inputs for valid positive integer values
	 */
	static positiveInteger(control: FormControl): { [key: string]: any } {
		if (!this.integer(control) && control.value > 0) {
			return null;
		} else {
			return { invalidPositiveInteger: true };
		}
	}

	/**
	 * Checks inputs for valid country
	 */
	static country(control: FormControl): { [key: string]: any } {
		const now = new Date();
		const endOfRegistration = CfeValidators.countryRegistrationEndDates.get(control.value);
		if (endOfRegistration == null) {
			return null;
		}

		if (control.dirty && new Date(endOfRegistration) <= now) {
			return { invalidCountry: true };
		} else {
			return null;
		}
	}

	/**
	 * Checks inputs for valid Mobile Phone Number
	 */
	static phoneNumber(control: FormControl): { [key: string]: any } {
		if (!control.value || control.value === '' || (CfeValidators.checkPhoneNumber(control.value) && control.value.toString().length > 6)) {
			return null;
		} else {
			return { invalidPhoneNumber: true };
		}
	}

	/**
	 * Checks inputs for Fax Number
	 */
	static faxNumber(control: FormControl): { [key: string]: any } {
		if (!control.value || control.value === '' || CfeValidators.checkFaxNumber(control.value)) {
			return null;
		} else {
			return { invalidFaxNumber: true };
		}
	}

	/**
	 * Checks inputs for valid Mobile Phone Number
	 */
	static atLeastOneIsChecked(control: FormControl): { [key: string]: any } {
		if (
			// No or empty value
			!control.value ||
			control.value === '' ||
			// Empty array
			control.value.length === 0 ||
			// All values are false
			!control.value.reduce((value, item) => value || item, false)
		) {
			return { missingCheck: true };
		} else {
			return null;
		}
	}

	static specialChars(control: FormControl): { [key: string]: any } {
		if (control.value) {
			if (control.value.toString().includes('>') || control.value.toString().includes('<')) {
				return { invalidCharacter: true };
			}
			return null;
		}
		return null;
	}

	/**
	 * Checks inputs for valid Mobile Phone Number
	 */
	static checkPhoneNumber(phoneNumber: string) {
		const patternNew = new RegExp(
			'^([+][0-9 ]{1,4}([ .\\-(])?)?([(]{1}[0-9]{3}[)])?([0-9A-Z .\\-\\\\)]{1,32})((x|ext|extension)?[0-9]{1,4}?)$'
		);

		return patternNew.test(phoneNumber);
	}

	/**
	 * Checks inputs for valid Fax Number
	 */
	static checkFaxNumber(faxNumber: string) {
		const patternNew = new RegExp(
			'^([+][0-9 ]{1,4}([ .\\-(])?)?([(]{1}[0-9]{3}[)])?([0-9A-Z .\\-\\\\)]{1,32})((x|ext|extension)?[0-9]{1,4}?)$'
		);

		return patternNew.test(faxNumber);
	}
}
